import React from 'react';
import {MeListItemData} from './hooks';
import {Image} from '@/components-v2/Image';
import {ReactComponent as ChavronRight} from '@/assets/icons/chavron-right.svg';

type MeListItemProps = MeListItemData;

const MeListItem = ({icon, title, rightContent, onClick}: MeListItemProps) => {
  return (
    <div
      className="mb-2 flex h-12 w-full items-center justify-between rounded-lg bg-white px-4 py-3"
      onClick={onClick}>
      <div className="flex flex-row items-center">
        <div className="mr-4 h-6 w-6">
          <Image src={icon} alt="item" className="size-6" />
        </div>
        <div className="text-sm font-medium text-t2">{title}</div>
      </div>
      <div className="flex flex-row items-center gap-x-3">
        {rightContent}
        <ChavronRight className="size-3.5 text-t4" />
      </div>
    </div>
  );
};

export default MeListItem;
